import { JsonQuery, TJsonQuery } from '../../../packages/JsonQuery';
import { TModifier } from 'shared/types/filters';

export function modifyJsonQuery(jsonQuery: TJsonQuery, modifiers: [TModifier, ...TModifier[]]): TJsonQuery {
  const jq = new JsonQuery(jsonQuery);

  modifiers.forEach(modifier => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (jq[modifier.action] as any)(...modifier.arguments);
  });

  return jq.toJSON();
}
